import EditAssetForm from 'components/Assets/AssetDetail/edit-asset'
import DialogPrompt from 'components/DialogPrompt'
import enums from 'Constants/enums'
import useFetchData from 'hooks/fetch-data'
import { get, isEmpty } from 'lodash'
import React, { useEffect, useState, useRef, useCallback } from 'react'
import updateAssetStatus from 'Services/Asset/updateAssetStatusService'
import reactFLow from 'Services/react-flow'
import { Toast } from 'Snackbar/useToast'
import $ from 'jquery'
import usePostData from 'hooks/post-data'
import toast from 'react-hot-toast'

const FlowComponent = () => {
  const [recivedObj, setRecivedObj] = useState(null)
  const recivedObjRef = useRef(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [nodeData, setNodeData] = useState({ list: [], initialEdges: [] })
  const [flowKey, setFlowKey] = useState(0) // Add a state to manage the key for re-rendering

  // Update ref whenever recivedObj changes
  useEffect(() => {
    recivedObjRef.current = recivedObj
  }, [recivedObj])

  const handleFormatter = data => {
    const subClassCodes = [
      'LAAR',
      'SPRT-LV',
      'BESS',
      'NICB',
      'VLAB',
      'VRLB',
      'PCAP',
      'SCAP',
      'AMCB',
      'CTCR',
      'ARCB',
      'GICB',
      'ICCB',
      'LVCB',
      'MCCB-L-LV',
      'MCCB-S-LV',
      'OICB',
      'RCLS',
      'VCCB',
      'FUSE-LV',
      'FUSE-MV',
      'BNDG',
      'GRND',
      'CITR',
      'PITR',
      'AMME',
      'LIMI',
      'MMME',
      'VVME',
      'WHME',
      'FUEL',
      'Other',
      'EMRE',
      'MPRE',
      'SSRE',
      'BISW-LV',
      'BISW-MV',
      'BPSW',
      'DISC-F-LV',
      'DISC-F-MV',
      'DISC-LV',
      'DISC-MV',
      'HPSW',
      'LISW',
    ]
    const { list = [], initialEdges = [] } = data

    const subcomponents = list.filter(item => item.extent === 'parent' && subClassCodes.includes(item.data.code))
    const topLevelComponents = list.filter(item => item.extent === null)
    const combinedList = [...topLevelComponents, ...subcomponents]
    setNodeData(!isEmpty(combinedList) ? { list: combinedList, initialEdges } : { list: [], initialEdges: [] })
  }

  const { reFetch } = useFetchData({ fetch: reactFLow.get, formatter: d => handleFormatter(get(d, 'data', null)), externalLoader: true })

  const handleDataChange = async updatedData => {
    $('#pageLoading').show()
    setNodeData({ list: [], initialEdges: [] })
    const recivedData = [...updatedData.changedNodes]
    const newData = recivedData.map(d => ({
      assetId: get(d, 'id', null),
      xAxis: Math.round(get(d, 'position.x', 0)),
      yAxis: Math.round(get(d, 'position.y', 0)),
    }))

    const res = await reactFLow.updatePosition({ assets: [...newData], edges: [] })
    if (res.success > 0) {
      Toast.success('Assets Positions Updated Successfully!')
      handleRefetch()
    } else if (res.success == -2) {
      Toast.success('You have not made any position changes')
      handleRefetch()
    } else {
      Toast.error('Something Went Wrong')
    }
    $('#pageLoading').hide()
  }
  const { mutate: updateEdges } = usePostData({
    executer: reactFLow.updatePosition,
    postSuccess: res => {
      const currentRecivedObj = recivedObjRef.current
      let successMessage = currentRecivedObj?.isDeleteEdges ? 'Edges Deleted Successfully!' : 'Edges Updated Successfully!'
      if (res.success === -62) successMessage = 'Unable to add this connection — it would create a loop.'
      if (!currentRecivedObj?.isOriantation) Toast.success(successMessage)
      handleRefetch()
    },
    postError: () => toast.error('Something went wrong'),
    hideMessage: true,
  })
  const submitData = async updateEdgesPayload => updateEdges(updateEdgesPayload)

  useEffect(() => {
    const onDataChangeHandler = event => {
      const { detail: updatedData } = event
      handleDataChange(updatedData)
    }
    const onSingleChangeHandler = event => {
      const { detail: updatedData } = event
      setRecivedObj(updatedData)
      if (updatedData.isEdgesChange) {
        const wrongId = updatedData.changeData.id?.split('_')[0]
        submitData({
          assets: [],
          edges: [
            {
              id: wrongId === 'xy-edge' ? null : get(updatedData, 'changeData.id', null),
              source: get(updatedData, 'changeData.source', '00000000-0000-0000-0000-000000000000'),
              target: get(updatedData, 'changeData.target', '00000000-0000-0000-0000-000000000000'),
              targetHandle: get(updatedData, 'changeData.targetHandle', null),
              isDeleted: false,
              label: get(updatedData, 'changeData.label', ''),
              style: JSON.stringify(get(updatedData, 'changeData.style', '')),
              fedbyDetailsJson: !isEmpty(updatedData.changeData.data) ? JSON.stringify(get(updatedData, 'changeData.data', '')) : null,
            },
          ],
        })
      } else if (updatedData.isDeleteEdges) {
        submitData({
          assets: [],
          edges: [
            {
              id: get(updatedData, 'changeData', null),
              isDeleted: true,
            },
          ],
        })
      } else if (updatedData.isOriantation) {
        const oriantationData = updatedData.changeData.map(d => ({
          assetId: get(d, 'id', null),
          xAxis: Math.round(get(d, 'position.x', 0)),
          yAxis: Math.round(get(d, 'position.y', 0)),
          assetOrientation: get(d, 'oriantation', null),
        }))
        submitData({ assets: oriantationData, edges: [] })
      }
    }
    document.addEventListener('datachange', onDataChangeHandler)
    document.addEventListener('singlechange', onSingleChangeHandler)
    return () => {
      document.removeEventListener('datachange', onDataChangeHandler)
      document.removeEventListener('singlechange', onSingleChangeHandler)
    }
  }, [])
  const handleRefetch = useCallback(() => {
    const currentRecivedObj = recivedObjRef.current
    if (!currentRecivedObj?.isOriantation) {
      setNodeData({ list: [], initialEdges: [] })
      reFetch()
      setFlowKey(prevKey => prevKey + 1)
    } else {
      setRecivedObj({ ...currentRecivedObj, isOriantation: false })
    }
  }, [reFetch])

  const handleDeleteNodeAsset = async () => {
    setDeleteLoading(true)
    try {
      const res = await updateAssetStatus({ asset_id: get(recivedObj, 'changeData', null), status: enums.assetStatus[3].id })
      if (res.data.success === 1) Toast.success(`Asset deleted successfully !`)
      else Toast.error(res.data.message ?? 'Something went wrong!')
      setDeleteLoading(false)
      handleRefetch()
      setRecivedObj({ isDeleting: false })
    } catch (error) {
      console.log(error)
      Toast.error('Something went wrong!')
      setDeleteLoading(false)
    }
  }

  const formConfigs = [
    {
      condition: get(recivedObj, 'isAdding', false),
      props: {
        open: get(recivedObj, 'isAdding', false),
        editType: 'ASSET',
        onClose: () => setRecivedObj({ isAdding: false }),
        isNew: true,
        status: 3,
        refetch: handleRefetch,
        nodePosition: get(recivedObj, 'changeData', null),
      },
    },
    {
      condition: get(recivedObj, 'isEditing', false),
      props: {
        open: get(recivedObj, 'isEditing', false),
        editType: 'ASSET',
        onClose: () => setRecivedObj({ isEditing: false }),
        status: 3,
        refetch: handleRefetch,
        nodePosition: get(recivedObj, 'changeData.position', null),
        mainListEdit: true,
        assetId: get(recivedObj, 'changeData.id'),
        name: get(recivedObj, 'changeData.data.label', ''),
      },
    },
    {
      condition: get(recivedObj, 'isAddingDownstream', false),
      props: {
        open: get(recivedObj, 'isAddingDownstream', false),
        editType: 'ASSET',
        onClose: () => setRecivedObj({ isAddingDownstream: false }),
        isNew: true,
        status: 3,
        refetch: handleRefetch,
        nodePosition: get(recivedObj, 'changeData.position', null),
        downStreamData: get(recivedObj, 'changeData', null),
      },
    },
    {
      condition: get(recivedObj, 'isAddingLineSide', false),
      props: {
        open: get(recivedObj, 'isAddingLineSide', false),
        editType: 'ASSET',
        onClose: () => setRecivedObj({ isAddingLineSide: false }),
        status: 3,
        refetch: handleRefetch,
        nodePosition: get(recivedObj, 'changeData.position', null),
        mainListEdit: true,
        isNew: true,
        downStreamData: get(recivedObj, 'changeData', null),
        isLoadLineSide: true,
      },
    },
  ]
  return (
    <>
      <react-flow key={flowKey} initialdata={JSON.stringify(nodeData)} />
      {formConfigs.map(({ condition, props }, index) => condition && <EditAssetForm key={index} {...props} />)}
      {get(recivedObj, 'isDeleting', false) && <DialogPrompt title='Delete Asset' text='Are you sure you want to delete this Asset ?' open={get(recivedObj, 'isDeleting', false)} ctaText='Delete' actionLoader={deleteLoading} action={handleDeleteNodeAsset} handleClose={() => setRecivedObj({ isDeleting: false })} />}
    </>
  )
}

export default FlowComponent
